import { root } from 'app/store/constants';
import { IAuthToken, IRestAuthUser } from 'app/types/rest/IRestAuthUser';
import { INIT_SCOPE } from 'app/helper/authorisation/google/Scopes';

// @ts-ignore
export const providerInstance: Promise<Provider> = window.gisLoaded.then(()=>{
    console.debug('new Google Provider()');
    return new Provider();
})

export interface IGoogleCodeResponce{
    code: string;
    authuser: string;
    error: string;
}

/***
 * класс отвечает за общение с Google
 */

export class Provider {
    authorizeWithCode (scopes: string[],code_challenge: string, code_challenge_method: string, hint?: string  ) {
        return new Promise<IGoogleCodeResponce>((resolve, reject) => {
            return new Promise<IRestAuthUser>((resolve,reject) =>{
                const authUrl = new URL('https://accounts.google.com/o/oauth2/auth');

                authUrl.searchParams.append('access_type', 'offline');
                authUrl.searchParams.append('client_id', root.App.clientId);
                authUrl.searchParams.append('response_type', 'code');
                authUrl.searchParams.append('code_challenge', code_challenge);
                authUrl.searchParams.append('code_challenge_method', code_challenge_method);
                authUrl.searchParams.append('redirect_uri', window.location.origin + '/loginRedirect');
                if (!new URLSearchParams(window.location.search).get('scope_error') || !new URLSearchParams(window.location.search).get('login_error')) {
                    authUrl.searchParams.append('state', JSON.stringify({afterLoginRedirectUrl: window.location.href}));
                }
                authUrl.searchParams.append('scope', scopes.join(' '));
                authUrl.searchParams.append('include_granted_scopes', 'true');

                if (hint) {
                    authUrl.searchParams.append('login_hint', hint);
                } else {
                    authUrl.searchParams.append('prompt', 'select_account');
                }

                window.open(authUrl.href, '_self');
            });

            // let client_id = root.App.clientId;
            // // @ts-ignore
            // let codeClient = google.accounts.oauth2.initCodeClient({
            //     client_id,
            //     scope: scopes.join(' '),
            //     ux_mode: 'popup',
            //     hint,
            //     callback: (response: IGoogleCodeResponce) => {
            //         //console.debug(response);
            //         resolve(response);
            //     },
            //     error_callback: (err: {type: string}) => {
            //         console.debug(err);
            //         reject(err);
            //         // нам сообщать что пользователь закрыл окно нет смысла, тк это тоже самое,
            //         // что он не нащал на конопку ЗАЛОГИНЬСЯ. reject будем вызывать когда что-то пошло не так
            //     }
            // });

            // codeClient.requestCode();
            }
        )
    }

    resetToken(){
        // @ts-ignore
        gapi.client.setToken({});
        // @ts-ignore
        window.google.authuser = undefined;
    }

    setToken(token: IAuthToken){
        // @ts-ignore
        gapi.client.setToken(token);
        // @ts-ignore
        window.google.authuser = token.authuser;
    }

    static getInitScopes(){
        return INIT_SCOPE;
    }
}
